import { render, staticRenderFns } from "./Subusers.vue?vue&type=template&id=54740396&scoped=true&"
import script from "./Subusers.vue?vue&type=script&lang=js&"
export * from "./Subusers.vue?vue&type=script&lang=js&"
import style0 from "./Subusers.vue?vue&type=style&index=0&id=54740396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54740396",
  null
  
)

export default component.exports